"use client";

import { SpaceBoi } from "@/components/modules/3d-components/space";
import Navi from "@/components/modules/navi";
import About from "@/components/sections/About";
import Contact from "@/components/sections/Contact";
import Experience from "@/components/sections/experience";
import Hero from "@/components/sections/Hero";
import Works from "@/components/sections/Works";

export default function Home() {
	return (
		<>
			<SpaceBoi />
			<Navi />
			<main className="relative w-full z-10">
				<Hero />
				<About />
				<Experience />
				<Works />
				<Contact />
				<div className="text-white p-3 sm:p-4 text-[10px] sm:text-xs bg-black bg-opacity-50">
					<p className="text-center sm:text-left">
						<a href="https://skfb.ly/oyXLG" className="hover:text-[#ffe36c] transition-colors">space boi</a> by silvercrow101 is
						licensed under{" "}
						<a href="http://creativecommons.org/licenses/by-nc/4.0/" className="hover:text-[#ffe36c] transition-colors">
							Creative Commons Attribution-NonCommercial
						</a>{" "}
						| © {new Date().getFullYear()} Andasan
					</p>
				</div>
			</main>
		</>
	);
}
